import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalBlockuserComponent } from '../modal-blockuser/modal-blockuser.component';
import { environment } from '@env/environment';
import { ChatModalInfo } from '@app/+chat/models/chat-modal-info.model';

@Component({
  selector: 'vc-modal-moreaction',
  templateUrl: './modal-moreaction.component.html',
  styleUrls: ['./modal-moreaction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalMoreactionComponent implements OnInit {
  public isBlocked = false;
  imgixPath = environment.imgixPath;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: ChatModalInfo,
    private dialogService: MatDialog,
    public dialogRef: MatDialogRef<ModalMoreactionComponent>
  ) {}

  ngOnInit() {
    this.isBlocked = this.data.receiverIsBlocked;
  }

  confirmBlockUser() {
    const dialogRefBU = this.dialogService.open(ModalBlockuserComponent, {
      height: '45vh',
      maxWidth: 600,
      position: { bottom: '0', left: '0', right: '0' },
      data: this.data
    });

    dialogRefBU.afterClosed().subscribe(
      result => {
        this.isBlocked = result;
        this.dialogRef.close(this.isBlocked);
      },
      err => {
        // Silently fails
      }
    );
  }

  onModalReportClick() {
    this.data.reportUserActivated = true;
    this.closeDialog(this.data);
  }

  closeDialog(data) {
    this.dialogRef.close(data);
  }
}
